import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex-basis-70 _flexcol _gap-3" }
const _hoisted_2 = { class: "_tc--gray _mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_product_comparison_modal = _resolveComponent("product-comparison-modal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.bannerClassList),
    "data-qa": "compare-rewards-section"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_heading, { tag: "h2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.CompareProductsBannerHeader), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.CompareProductsBannerDescription), 1 /* TEXT */),
      _createElementVNode("div", null, [
        _createVNode(_component_base_button, {
          theme: "accent",
          onClick: $options.openCompareProductsModal,
          "data-qa": "compare-rewards-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.CompareProductsBannerCompareButtonText) + " ", 1 /* TEXT */),
            _createVNode(_component_base_icon, { name: "angle-right" })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ]),
    _createVNode(_component_themed_image, {
      src: "/content/images/static/products/product-comparison.svg",
      alt: "Product comparison",
      class: _normalizeClass($options.imageClassList)
    }, null, 8 /* PROPS */, ["class"]),
    ($data.isProductComparisonModalVisible)
      ? (_openBlock(), _createBlock(_component_product_comparison_modal, {
          key: 0,
          "project-id": $options.projectID,
          onClose: $options.closeCompareProductsModal
        }, null, 8 /* PROPS */, ["project-id", "onClose"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}